import {useCallback, useRef, useState} from 'react';
import {BehaviorSubject, Observable} from 'rxjs';

export type UsePopupTriggerHook = {
    visibility$: Observable<boolean>,
    toggleVisibility: () => void,
    show: () => void,
    hide: () => void,
};
export const usePopupTrigger$ = (): UsePopupTriggerHook => {
    const [visibility$] = useState(new BehaviorSubject(false));

    const toggleVisibility = useCallback(() => {
        visibility$.next(!visibility$.getValue());
    }, [visibility$]);

    const show = useCallback(() => {
        visibility$.next(true);
    }, [visibility$]);

    const hide = useCallback(() => {
        visibility$.next(false);
    }, [visibility$]);

    const readOnlyVisibility$ = useRef(visibility$.asObservable());

    return {
        toggleVisibility,
        show,
        hide,
        visibility$: readOnlyVisibility$.current,
    };
};
